module.exports = __webpack_public_path__ + "img/horizontal_7_5_pp3_6005.3f40d3a0.png";